const AutomaticSystemsTypes = {
  SET_INITIALIZED: "automaticSystems/SET_INITIALIZED",
  SET_AUTOMATIC_SYSTEMS: "automaticSystems/SET_AUTOMATIC_SYSTEMS",
  SET_AUTOMATIC_SYSTEMS_DETAILS:
    "automaticSystems/SET_AUTOMATIC_SYSTEMS_DETAILS",
  SET_AUTOMATIC_SYSTEMS_LOADING:
    "automaticSystems/SET_AUTOMATIC_SYSTEMS_LOADING",
  SET_AUTOMATIC_SYSTEMS_DETAILS_LOADING:
    "automaticSystems/SET_AUTOMATIC_SYSTEMS_DETAILS_LOADING",
  SET_AUTOMATIC_SYSTEMS_STATUS_LOADING:
    "automaticSystems/SET_AUTOMATIC_SYSTEMS_STATUS_LOADING",
  SET_AUTOMATIC_SYSTEMS_MODE_LOADING:
    "automaticSystems/SET_AUTOMATIC_SYSTEMS_MODE_LOADING",
};

export default AutomaticSystemsTypes;
